export const name = 'cyclicTabbingService' as const
